import type { ShortcutsBlockProps } from "./types";

import { Heading } from "@digdir/designsystemet-react";

export type { ShortcutsBlockProps };

const colorMap = {
  Blue: {
    bg: "bg-tinted",
    btnText: "text-main",
    btnBorder: "border-main-subtle",
    btnBg:
      "bg-main-surface-tinted hover:bg-main-surface-hover active:bg-main-surface-active",
    btnSelected: "bg-main-surface-active",
  },
  Red: {
    bg: "bg-tinted-danger",
    btnText: "text-support",
    btnBorder: "border-support-subtle",
    btnBg:
      "bg-support-surface-tinted hover:bg-support-surface-hover active:bg-support-surface-active",
    btnSelected: "bg-support-surface-active",
  },
  Default: {
    bg: "bg-white",
    btnText: "text-neutralNsf",
    btnBorder: "border-neutralNsf-subtle",
    btnBg:
      "bg-neutralNsf-surface-tinted hover:bg-neutralNsf-surface-hover active:bg-neutralNsf-surface-active",
    btnSelected: "bg-neutralNsf-surface-active",
  },
} as const;

const ShortcutsBlock = ({
  heading,
  colorTheme,
  items,
}: ShortcutsBlockProps) => {
  const theme = colorTheme ? colorMap[colorTheme] : colorMap.Default;

  return (
    <nav className={`${theme.bg} full-bleed py-9 md:py-10 xl:py-12`}>
      <div className="content px-4">
        {heading && <Heading className="heading-md mb-4">{heading}</Heading>}
        <ul className="grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-8 lg:justify-between">
          {items.map((link) => (
            <li key={link.title} className="!mb-0">
              <a
                href={link.url}
                className={`flex items-center w-full h-full p-4.5 heading-xs font-medium border outline-[3px] focus-visible:outline-focusOuter focus-visible:outline md:p-5.5 xl:p-6.5
                  ${theme.btnText}  ${theme.btnBorder}
                  ${link.isSelected ? theme.btnSelected : theme.btnBg}
                `}
                target={link.target ?? "_self"}
                rel={
                  link.target === "_blank" ? "noopener noreferrer" : undefined
                }
              >
                {link.title}
                {link.target === "_blank" && (
                  <span className="sr-only"> (åpnes i ny fane)</span>
                )}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default ShortcutsBlock;
